// @flow

import {
    createChatParticipantTableColumn,
    createChatMessageContentTableColumn,
} from '../../../lib/trix-web-components-domain-social';

export const components = {
    'tableColumn:chatParticipant': createChatParticipantTableColumn,
    'tableColumn:chatMessageContent': createChatMessageContentTableColumn,
}

